/* Angular */
import { createReducer, on } from '@ngrx/store';

/* Functions */
import { updateEntityInArray } from 'src/app/features/shared/functions';

/* actions */
import * as ProviderDataStoreActions from './provider-data-store.actions';

import { Provider } from 'src/app/features/shared/models';

/* State key */
export const featureKey = 'ProviderDataStore';

/* State interface */
export interface ProviderState {
  isLoading?: boolean;
  providers?: Provider[];
  activeProvider?: Provider;
}

/* Initial values */
export const initialState: ProviderState = {
  isLoading: null,
  providers: null,
  activeProvider: null,
};

export const reducer = createReducer(
  initialState,
  on(ProviderDataStoreActions.GetProviders, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(ProviderDataStoreActions.GetProvidersSuccessful, (state, action) => ({
    ...state,
    providers: action.payload.providers,
    isLoading: false,
  })),

  on(ProviderDataStoreActions.GetProvidersFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(ProviderDataStoreActions.GetProviderById, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(ProviderDataStoreActions.GetProviderByIdSuccessful, (state, action) => ({
    ...state,
    /* TODO: replace item by id from data array */
    isLoading: false,
  })),

  on(ProviderDataStoreActions.GetProviderByIdFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(ProviderDataStoreActions.CreateProvider, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(ProviderDataStoreActions.CreateProviderSuccessful, (state, action) => ({
    ...state,
    providers: [...(state.providers ?? []), action.payload.provider],
    isLoading: false,
  })),

  on(ProviderDataStoreActions.CreateProviderFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(ProviderDataStoreActions.UpdateProvider, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(ProviderDataStoreActions.UpdateProviderSuccessful, (state, action) => ({
    ...state,
    providers: updateEntityInArray<Provider>(
      action.payload.id,
      action.payload.data,
      state.providers ?? [],
    ),
    isLoading: false,
  })),

  on(ProviderDataStoreActions.UpdateProviderFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(ProviderDataStoreActions.DeleteProvider, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(ProviderDataStoreActions.DeleteProviderSuccessful, (state, action) => ({
    ...state,
    providers:
      state.providers?.filter((item) => action.payload.id !== item.id) ?? [],
    isLoading: false,
  })),

  on(ProviderDataStoreActions.DeleteProviderFailure, (state, action) => ({
    ...state,
    isLoading: false,
  })),

  on(ProviderDataStoreActions.ResetState, () => initialState),
);
